
import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import TranslationTypeSelect from './TranslationTypeSelect.vue'
import ExtractOption from './ExtractOption.vue'

@Component({
  components: { TranslationTypeSelect, ExtractOption }
})
export default class ActivityCreateForm extends Vue {
  @Prop({ type: String, default: 'customer-template' })
  readonly initialDocumentType!: string

  @Prop({ type: String, default: 0 })
  readonly initialTemplateId?: string

  @Prop({ type: Array, required: true })
  readonly templates!: any[]

  @Prop({ type: Object, default: () => ({}) })
  readonly providerPricing!: any

  @Prop({ type: Object, required: true })
  readonly fee: any

  translationType = ''

  documentType = 'provider-template'

  templateId: number | null = null

  selectedFiles: File[] = []

  get documentationLink() {
    return 'https://acudocx.com.au/how-it-works-translator-tool/'
  }

  get isMobile() {
    return this.$vuetify.breakpoint.xsOnly
  }

  @Watch('initialTemplateId')
  initialTemplateIdChanged(val: number) {
    this.templateId = val
  }

  @Watch('initialDocumentType')
  initialDocumentTypeChanged(val: string) {
    if (val === 'adhoc') {
      this.translationType = 'full-translation'
    } else {
      this.translationType = 'extract'
    }
    this.documentType = val
  }

  submit() {
    if (this.translationType === 'full-translation') {
      this.makeFullTranslation()
    } else {
      this.documentType = 'provider-template'
    }
    const form = this.$refs.form as any

    if (form.validate()) {
      this.$emit('submit', { type: this.documentType, templateId: this.templateId })
    }
  }

  makeFullTranslation() {
    this.translationType = 'full-translation'
    this.documentType = 'adhoc'
    this.templateId = null
  }
}
